"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleButtonWrapper = exports.StyleButton = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./StyleButton.css"));
var BackgroundStyleButton_1 = require("./BackgroundStyleButton/BackgroundStyleButton");
var inversify_1 = require("inversify");
var BlockStore_1 = __importDefault(require("Project/Stores/BlockStore"));
var DIProvider_1 = __importDefault(require("@CommonFrontend/DIProvider/DIProvider"));
var BrandStore_1 = __importDefault(require("DreamCoat/BrandSetUp/BrandStore/BrandStore"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var inversify_react_1 = require("inversify-react");
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var StyleLibraryV2_1 = __importDefault(require("DreamCoat/SavedStyle/StyleLibraryV2/StyleLibraryV2"));
var SavedStyleService_1 = __importDefault(require("DreamCoat/SavedStyle/SavedStyleService/SavedStyleService"));
var FeatureFlag_1 = __importStar(require("@CommonFrontendBackend/FeatureFlag"));
var BlockStyleStore_1 = require("Project/Stores/BlockStyleStore");
var StyleButton = (function (_super) {
    __extends(StyleButton, _super);
    function StyleButton() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.getHasStyleChangedFromLibrary = function () {
            var blockStyleStoreModel = (0, BlockStyleStore_1.getNonSourceBlockStyle)(_this.blockStore.blockStyleStore);
            var savedStyles = _this.savedStyleService.getSavedStylesByBlockType(_this.blockStore.blockType);
            return savedStyles.some(function (style) { return blockStyleStoreModel.clonedFrom === style._id && blockStyleStoreModel.hash !== style.hash; });
        };
        return _this;
    }
    StyleButton.prototype.getBlockBackground = function () {
        var blockStyleStore = this.blockStore.blockStyleStore;
        var getColorFn = (0, GetBlockStyle_1.GetColor)(this.brandStore.allColors);
        if ("background" in blockStyleStore.model && "type" in blockStyleStore.model.background) {
            if (blockStyleStore.model.background.type === "image" && blockStyleStore.model.background.url) {
                return { type: "image", url: blockStyleStore.model.background.url };
            }
            else if (blockStyleStore.model.background.type === "video") {
                return {
                    type: "video",
                    thumbnailUrl: blockStyleStore.model.background.videoThumbnail || "",
                };
            }
        }
        return {
            type: "color",
            color: "background" in blockStyleStore.model ? getColorFn(blockStyleStore.model.background) : DefaultColors_1.DEFAULT_WHITE.value,
        };
    };
    StyleButton.prototype.render = function () {
        var _a = this.props, onBlockStyleButtonClick = _a.onBlockStyleButtonClick, onLibraryClick = _a.onLibraryClick, shouldShowBlockStyleButton = _a.shouldShowBlockStyleButton, shouldShowBlockBackgroundStyleButton = _a.shouldShowBlockBackgroundStyleButton;
        var background = this.getBlockBackground();
        var hasStyleChangedFromLibrary = this.getHasStyleChangedFromLibrary();
        return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.styleButtonWrapper, direction: "horizontal" },
            shouldShowBlockStyleButton && (react_1.default.createElement(kaleidoscope_1.IconButton, { className: styles.blockStyleButton, isRound: true, isIconOnly: true, size: kaleidoscope_1.ButtonSize.Small, icon: react_1.default.createElement(icons_1.Styles, null), tooltip: {
                    content: "Block style",
                    position: kaleidoscope_1.TooltipPosition.Top,
                }, onClick: onBlockStyleButtonClick })),
            shouldShowBlockBackgroundStyleButton && react_1.default.createElement(BackgroundStyleButton_1.BackgroundStyleButton, { blockBackground: background }),
            this.usingFeature(FeatureFlag_1.default.StyleLibraryRefresh) ? (react_1.default.createElement(react_1.default.Fragment, null,
                hasStyleChangedFromLibrary && react_1.default.createElement("div", { className: styles.indicator }),
                react_1.default.createElement(StyleLibraryV2_1.default, null))) : (react_1.default.createElement(kaleidoscope_1.IconButton, { className: styles.styleLibraryButton, isRound: true, isIconOnly: true, size: kaleidoscope_1.ButtonSize.Small, icon: react_1.default.createElement(icons_1.StylesLibrary, null), tooltip: {
                    content: "Style library",
                    position: kaleidoscope_1.TooltipPosition.Top,
                }, onClick: onLibraryClick }))));
    };
    var _a, _b, _c, _d;
    __decorate([
        (0, inversify_react_1.resolve)("brandStore"),
        __metadata("design:type", typeof (_a = typeof BrandStore_1.default !== "undefined" && BrandStore_1.default) === "function" ? _a : Object)
    ], StyleButton.prototype, "brandStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("blockStore"),
        __metadata("design:type", typeof (_b = typeof BlockStore_1.default !== "undefined" && BlockStore_1.default) === "function" ? _b : Object)
    ], StyleButton.prototype, "blockStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("usingFeature"),
        __metadata("design:type", typeof (_c = typeof FeatureFlag_1.usingFeatureType !== "undefined" && FeatureFlag_1.usingFeatureType) === "function" ? _c : Object)
    ], StyleButton.prototype, "usingFeature", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("savedStyleService"),
        __metadata("design:type", typeof (_d = typeof SavedStyleService_1.default !== "undefined" && SavedStyleService_1.default) === "function" ? _d : Object)
    ], StyleButton.prototype, "savedStyleService", void 0);
    StyleButton = __decorate([
        mobx_react_1.observer
    ], StyleButton);
    return StyleButton;
}(react_1.default.Component));
exports.StyleButton = StyleButton;
var StyleButtonWrapper = function (_a) {
    var blockStore = _a.blockStore, brandStore = _a.brandStore, isLastBlock = _a.isLastBlock, isSidebarOpened = _a.isSidebarOpened, stylePermissionStore = _a.stylePermissionStore, savedStyleService = _a.savedStyleService, styleModalService = _a.styleModalService, telemetry = _a.telemetry, usingFeature = _a.usingFeature, rest = __rest(_a, ["blockStore", "brandStore", "isLastBlock", "isSidebarOpened", "stylePermissionStore", "savedStyleService", "styleModalService", "telemetry", "usingFeature"]);
    return (react_1.default.createElement(DIProvider_1.default, { container: function () {
            var container = new inversify_1.Container();
            container.bind("blockStore").toConstantValue(blockStore);
            container.bind("brandStore").toConstantValue(brandStore);
            container.bind("isLastBlock").toConstantValue(isLastBlock);
            container.bind("isSidebarOpened").toConstantValue(isSidebarOpened);
            container.bind("stylePermissionStore").toConstantValue(stylePermissionStore);
            container.bind("savedStyleService").toConstantValue(savedStyleService);
            container.bind("styleModalService").toConstantValue(styleModalService);
            container.bind("telemetry").toConstantValue(telemetry);
            container.bind("usingFeature").toConstantValue(usingFeature);
            return container;
        } },
        react_1.default.createElement(StyleButton, __assign({}, rest))));
};
exports.StyleButtonWrapper = StyleButtonWrapper;
exports.default = (function (mountReactComponent, styleButtonStore, onLibraryClick, onBlockStyleButtonClick, blockStore, brandStore, isLastBlock, isSidebarOpened, stylePermissionStore, savedStyleService, styleModalService, telemetry, usingFeature) {
    return mountReactComponent(react_1.default.createElement(exports.StyleButtonWrapper, { blockStore: blockStore, brandStore: brandStore, isLastBlock: isLastBlock, isSidebarOpened: isSidebarOpened, shouldShowBlockStyleButton: styleButtonStore.shouldShowBlockStyleButton, shouldShowBlockBackgroundStyleButton: styleButtonStore.shouldShowBlockBackgroundStyleButton, onLibraryClick: onLibraryClick, onBlockStyleButtonClick: onBlockStyleButtonClick, stylePermissionStore: stylePermissionStore, savedStyleService: savedStyleService, styleModalService: styleModalService, telemetry: telemetry, usingFeature: usingFeature }));
});
